import { FEATURE_LABELS, checkLabel } from '../reportParams';
import type { FailureDetail } from '../types';

export const screenedAt = (iso: string) => new Date(iso)
  .toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });

const contextValue = (context: Record<string, unknown>, key: string) => {
  const value = context[key];
  return value == null ? null : String(value);
};

// Feature · grade · mode · district, skipping whatever the row didn't record.
export const contextLine = (detail: FailureDetail) => {
  const grade = contextValue(detail.context, 'grade_level');
  const mode = contextValue(detail.context, 'mode');

  return [
    FEATURE_LABELS[detail.feature] ?? checkLabel(detail.feature),
    grade && `Grade ${grade}`,
    mode && `${checkLabel(mode)} mode`,
    detail.subscriber?.name,
  ].filter(Boolean).join(' · ');
};
